import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'

const getNumberFromTitle = (entity: OldEntityInterface) =>
  parseInt(entity.options.title.replace(/\D/g, ''))

export const getSortedPopupList = (entities: OldEntityInterface[]) => {
  return entities.sort((a, b) => getNumberFromTitle(a) - getNumberFromTitle(b))
}
